import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useDeleteStoryMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const deleteStory = async (storyId) => {
    const url = encodeURI(`${env.apiUrl}/stories/${storyId}`)
    const response = await securedFetch(url, { method: 'DELETE' })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ categoryId, storyId }) => deleteStory(storyId),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error deleting story'),
    onSuccess: (data, { categoryId }) => {
      setMessage('Story was deleted')
      queryClient.invalidateQueries({ queryKey: ['stories', categoryId] })
    },
    onSettled: progressEnd
  })
}

export { useDeleteStoryMutation }
